import SearchIcon from "@mui/icons-material/Search";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import useMediaQuery from "@mui/material/useMediaQuery";
import ConfirmDialog from "components/common/ConfirmDialog";
import {ConfirmTextButton} from "components/common/CustomButtons";
import ProfileChangePassword from "components/profile/ProfileChangePassword";
import ProfileChangeSignature from "components/profile/ProfileChangeSignature";
import UserAvatar from "components/profile/UserAvatar";
import React, {Fragment, useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";
import {Link} from "react-router-dom";
import WebNotificationDialog from "../common/WebNotificationDialog";
import {Paths} from "../common/navigation";
import {actions, currentFirstNameSelector, currentUserIdSelector, currentUserSelector} from "../login/logic/actions";
import globalActions from "./logic/actions";

import PropTypes from "prop-types";
import useNotificationAtFive, {
    buildUnreportedCountMessage,
    getUnreportedCount,
} from "../../hooks/useNotificationAtFive";
import NotificationBell from "../common/NotificationBell";
import {MENU_CLOSE_RESPONSIVE_MATCH} from "components/global/Topbar";
import useGlobalSearchEnabled from "components/global/useGlobalSearchEnabled";
import { isReadOnlyRole } from "../login/logic/sagas";

function RightMenu({ onOpenSearch = () => {}, logout, firstName = "", ssoEnabled = false}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openChangePassword, setOpenChangePassword] = useState(false);
    const [openSignatureChange, setOpenSignatureChange] = useState(false);
    const [showConfirm, setShowModal] = useState(false);
    const [isLogoutAction, setIsLogoutAction] = useState(false);
    const open = Boolean(anchorEl);
    const isSmallDevice = useMediaQuery(MENU_CLOSE_RESPONSIVE_MATCH);
    const [unreportedMsg, setUnreportedMsg] = useState("");
    const user = useSelector(currentUserSelector);
    const [isReadOnlyUser, setIsReadOnlyUser] = useState(true);
    const userId = useSelector(currentUserIdSelector);
    const globalSearchEnabled = useGlobalSearchEnabled();

    useEffect(() => {
        if (user) {
            setIsReadOnlyUser(isReadOnlyRole(user));
        }
    }, [user]);

    const { onClickNotification } = useNotificationAtFive((message) => {
        setShowModal(true);
        setUnreportedMsg(message);
    });

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const openSearch = () => {
        onOpenSearch();
    };

    function handleChangePassword() {
        setOpenChangePassword(true);
        handleClose();
    }

    function handleChangeSignature() {
        setOpenSignatureChange(true);
        handleClose();
    }
    function onOpenProfile() {
        handleClose();
    }

    function handleCloseChangePassword() {
        setOpenChangePassword(false);
    }

    async function handleClickLogout() {
        setIsLogoutAction(true);
        setAnchorEl(null);
        const response = await getUnreportedCount(userId);
        if (response > 0) {
            const newMessage = buildUnreportedCountMessage(response);
            setUnreportedMsg(newMessage);
            setShowModal(true);
        } else logout();
    }

    function onCancelAction() {
        if (isLogoutAction) {
            setIsLogoutAction(false);
            setShowModal(false);
            logout();
        } else setShowModal(false);
    }

    function onConfirmAction() {
        setShowModal(false);
        onClickNotification();
    }

    return (
        <Fragment>
            {isSmallDevice && globalSearchEnabled && (
                <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={openSearch}
                    color="inherit"
                >
                    <SearchIcon />
                </IconButton>
            )}

            {!isReadOnlyUser && <NotificationBell />}

            <IconButton
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="inherit"
            >
                <UserAvatar styleDimensions={{ width: 24, height: 24 }} />
            </IconButton>

            <Menu
                elevation={1}
                id={"user_menu"}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={open}
                onClose={handleClose}
            >
                <MenuItem disabled>
                    {firstName}
                    <Divider />
                </MenuItem>

                <Link style={{ textDecoration: "unset", color: "initial" }} to={Paths.PROFILE}>
                    <MenuItem onClick={onOpenProfile}>Profile</MenuItem>
                </Link>

                <MenuItem onClick={handleChangePassword} disabled={ssoEnabled}>
                    Change password
                </MenuItem>
                <MenuItem onClick={handleChangeSignature}>Change signature</MenuItem>
                <MenuItem onClick={handleClickLogout}>Logout</MenuItem>
            </Menu>

            {openChangePassword && <ProfileChangePassword onClose={handleCloseChangePassword} />}
            {openSignatureChange && <ProfileChangeSignature onClose={setOpenSignatureChange} />}

            {}
            <WebNotificationDialog />

            {showConfirm && (
                <ConfirmDialog
                    open={showConfirm}
                    message={unreportedMsg}
                    title="Warning"
                    btnConfirm={<ConfirmTextButton onClick={onConfirmAction}>YES</ConfirmTextButton>}
                    closeText="NO"
                    onCancel={onCancelAction}
                />
            )}
        </Fragment>
    );
}

RightMenu.propTypes = {
    logout: PropTypes.func.isRequired,
    firstName: PropTypes.string,
    ssoEnabled: PropTypes.bool,
    onOpenSearch: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
    logout: () => dispatch(actions.LOGOUT.send()),
    onOpenSearch: () => dispatch(globalActions.TOGGLE_GLOBAL_SEARCH_BTN.call(true)),
});

const stateProps = (state) => ({
    firstName: currentFirstNameSelector(state),
    ssoEnabled: state.login.user != null && state.login.user.ssoEnabled
});

export default connect(stateProps, mapDispatchToProps)(RightMenu);
